export default __webpack_public_path__ + "static/media/hand-shake.2104499b.png";